<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline"
                style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备名称">
                <a-input v-model="query.deviceName"
                         placeholder="请输入设备名称"
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备编号">
                <a-input v-model="query.deviceNo"
                         placeholder="请输入设备编号"
                         allow-clear />
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="12">
              <a-form-item label="设备类型">
                <a-select placeholder="请选择设备类型" @change="handleChange" v-model="query.deviceType">
                  <a-select-option v-for="(item, index) in typelist" :key="index" :value="item">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="6"
                   :sm="12"
                   style="display: flex">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 12px"
                        @click="addOrUpdateHandle()">新增</a-button>
              <a-button type="danger"
                        style="margin-left: 12px"
                        @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table ref="table"
               rowKey="id"
               :columns="columns"
               :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
               :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
               :data-source="list"
               :pagination="pagination"
               @change="pageChange"
               bordered>
        <span slot="action"
              slot-scope="text, record">
          <a @click="Handle(record.id)">编辑</a>
        </span>
        <span slot="openState"
              slot-scope="text">
          <a-tag color="#f12b35"
                 v-if="text == 0">不开启</a-tag>
          <a-tag color="rgb(50, 205, 50)"
                 v-else>开启</a-tag>
        </span>
      </a-table>
      <a-modal title="新增"
               width="50%"
               v-model="addOrUpdateVisible"
               @ok="handleOk"
               @cancel="handleCancel">
        <a-form :form="addOrUpdateForm"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }">
          <a-form-item label="设备名称">
            <a-select :disabled="disabled"
                      v-decorator="['deviceId', { rules: [{ required: true, message: '请选择设备名称' }] }]"
                      placeholder="请选择设备名称">
              <a-select-option v-for="(item, index) in equipmentList"
                               :key="index"
                               :value="item.key">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="参数名称">
            <a-select :disabled="disabled"
                      v-decorator="['pmtId', { rules: [{ required: true, message: '请选择参数名称' }] }]"
                      placeholder="请选择参数名称">
              <a-select-option v-for="(item, index) in parameterList"
                               :key="index"
                               :value="item.key">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="是否开启报警">
            <a-radio-group v-decorator="['openState', { initialValue: 0, rules: [{ required: true }] }]"
                           style="width: 100%">
              <a-radio :value="0">不开启</a-radio>
              <a-radio :value="1">开启</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="正常值">
            <a-input v-decorator="['normalValue', { rules: [{ required: true, message: '请输入正常值!' }] }]" />
          </a-form-item>
          <a-form-item label="报警值最大值">
            <a-input v-decorator="['alarmValueMax', { rules: [{ required: true, message: '请输入报警值最大值!' }] }]" />
          </a-form-item>
          <a-form-item label="预警值最大值">
            <a-input v-decorator="['earlyValueMax', { rules: [{ required: true, message: '请输入预警值最大值!' }] }]" />
          </a-form-item>
          <a-form-item label="预警值最小值">
            <a-input v-decorator="['earlyValueMin', { rules: [{ required: true, message: '请输入预警值最小值!' }] }]" />
          </a-form-item>

          <a-form-item label="报警值最小值">
            <a-input v-decorator="['alarmValueMin', { rules: [{ required: true, message: '请输入报警值最小值!' }] }]" />
          </a-form-item>

          <span style="text-align: center; display: block; color: #e01414">报警最大值 > 预警最大值 > 预警最小值 > 报警最小值</span>
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      currentId: '',
      isUpdate: false,
      disabled: false,
      equipmentList: [],
      parameterList: [],
      queryUrl: '/pipe-network/alarm_tsl_configs/page',
      modifyUrl: '/pipe-network/alarm_pmt_configs',
      addOrUpdateUrl: '/pipe-network/alarm_tsl_configs',
      deleteUrl: '/pipe-network/alarm_tsl_configs', // 删除数据url
      queryOneUrl: '/pipe-network/alarm_tsl_configs',
      visible: false,
      confirmLoading: false,
      list: [],
      typelist: ['加压设备', '加药设备', '其它设备'],
      query: {
        deviceType: '',
        deviceId: '',
        deviceName: '',
        sysType: '水源',
        tenantId: this.$store.state.user.info.tenantId
      },
      columns: [
        {
          title: '设备名称',
          dataIndex: 'deviceName'
        },
        {
          title: '参数名称',
          dataIndex: 'pmtName'
        },
        {
          title: '是否开启报警',
          dataIndex: 'openState',
          scopedSlots: { customRender: 'openState' }
        },
        {
          title: '正常值',
          dataIndex: 'normalValue'
        },
        {
          title: '预警值',
          children: [
            {
              title: '最小值',
              dataIndex: 'earlyValueMin',
              key: 'earlyValueMin'
            },
            {
              title: '最大值',
              dataIndex: 'earlyValueMax',
              key: 'earlyValueMax'
            }
          ]
        },
        {
          title: '报警值',
          children: [
            {
              title: '最小值',
              dataIndex: 'alarmValueMin',
              key: 'alarmValueMin'
            },
            {
              title: '最大值',
              dataIndex: 'alarmValueMax',
              key: 'alarmValueMax'
            }
          ]
        },
        {
          title: '更改时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          scopedSlots: { customRender: 'action' }
        }
      ],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },
  mounted () {
    this.queryList()
  },
  created () {
    this.equipmentSelect()
    this.parameterSelect()
    this.resetList()
  },
  methods: {
    equipmentSelect () {
      const params = {
        sysType: 4
      }
      this.$http.get('/pipe-network/water_works_devices/list', { params }).then((res) => {
        console.log(res.data, 'kkk')
        // this.equipmentList = res.data.deviceName
        const list = []
        res.data.map((item) => {
          console.log(item)
          list.push({
            title: item.deviceName,
            key: item.id
          })
        })
        this.equipmentList = list
        console.log(this.equipmentList, 'sdfsdffdsfsdf')
      })
    },
    parameterSelect () {
      const params = {
        sysType: '水厂'
      }
      this.$http.get('/pipe-network/alarm_pmt_configs/list', { params }).then((res) => {
        console.log(res.data, 'kkk')
        // this.equipmentList = res.data.deviceName
        const list = []
        res.data.map((item) => {
          console.log(item)
          list.push({
            title: item.name,
            key: item.id
          })
        })
        this.parameterList = list
        console.log(this.parameterList, 'sdfsdffdsfsdf')
      })
    },
    handleChange (e) { },
    Handle (e) {
      this.disabled = true
      this.addOrUpdateHandle(e)
      this.showModal()
      this.resetList()
    },
    showModal () {
      this.visible = true
    },
    modify (values) {
      console.log(values, 'fsdfs')
      const params = {
        // id: values.id,
        deviceName: values.deviceName,
        temperatureMin: values.temperatureMin,
        voltageMax: values.voltageMax,
        voltageMin: values.voltageMin,
        electricityMax: values.electricityMax,
        electricityMin: values.electricityMin,
        waterLevelMax: values.waterLevelMax,
        waterLevelMin: values.waterLevelMin
      }
      const header = {
        'Content-Type': 'application/json',
        Authorization: this.token
      }
      this.$http({
        url: this.modifyUrl,
        data: params,
        headers: header,
        method: 'post'
      }).then((data) => {
        this.queryList()
        this.visible = false
        this.visible = false
        this.confirmLoading = false
        this.$message.success('设置成功')
      })
    },
    // 取消
    handleCancel (e) {
      console.log('Clicked cancel button')
      this.visible = false
      this.disabled = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
